var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBusketCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.336,
    height: 25.781,
    viewBox: "0 0 19.336 25.781",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-clipboard-check",
    "data-name": "Icon awesome-clipboard-check",
    d: "M16.919,3.223H12.89a3.223,3.223,0,0,0-6.445,0H2.417A2.418,2.418,0,0,0,0,5.64V23.364a2.418,2.418,0,0,0,2.417,2.417h14.5a2.418,2.418,0,0,0,2.417-2.417V5.64A2.418,2.418,0,0,0,16.919,3.223ZM9.668,2.014A1.208,1.208,0,1,1,8.459,3.223,1.206,1.206,0,0,1,9.668,2.014Zm6.1,11.672-7.2,7.14a.6.6,0,0,1-.856-.005L3.555,16.627a.6.6,0,0,1,.005-.856l1.43-1.42a.6.6,0,0,1,.856.005l2.316,2.336,5.337-5.3a.6.6,0,0,1,.856.005l1.42,1.43A.6.6,0,0,1,15.771,13.686Z",
    fill: "#d00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBusketCheck);
export default __webpack_public_path__ + "static/media/icon-busket-check.f50ea06d80cf390318037cafa2a5a154.svg";
export { ForwardRef as ReactComponent };